import { computed, ref, watch } from 'vue'

/** Keep selection separate from the draft and reveal entries requested by issue navigation. */
export function useEntitySelection(props, kind) {
  const requested_id = ref('')
  const entries = computed(() => props.modelValue[kind] ?? [])
  const selected_id = computed({
    get: () => entries.value.some(item => item.id === requested_id.value)
      ? requested_id.value : entries.value[0]?.id ?? '',
    set: value => { requested_id.value = value },
  })
  watch(() => props.focus_target, target => {
    if (!props.guided || !target?.path) return
    const parts = target.path.split('.')
    if (parts[0] === kind && /^\d+$/.test(parts[1] ?? '')) {
      const item = entries.value[Number(parts[1])]
      if (item) selected_id.value = item.id
    } else if (kind === 'characters' && parts[0] === 'initial_state' && parts[1] === 'positions') {
      selected_id.value = parts[2]
    }
  }, { immediate: true })

  return { selected_id }
}
